import { useRollbar } from '@rollbar/react'
import * as blogApi from 'client/api/blogApi'
import useDynamicStore from 'client/hooks/useDynamicStore'
import { usePage } from 'client/store'
import * as blogPostActions from 'client/store/blogPost/blogPostActions'
import blogPostReducer from 'client/store/blogPost/blogPostReducer'
import { pageSelectors } from 'client/store/page/pageSelectors'
import { InternalError } from 'common/errors'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useCalculateTypography } from 'src/editor/shared/hooks/use-calculate-typography'
import useBlogData from '../../hooks/useBlogData'
import { ActivePopup } from '../components/popup/active-popup'
import PageUi from '../ui/PageUi'

function BlogPost({ children }: { children: React.ReactNode }) {
  useBlogData()
  useDynamicStore({ key: 'blogPost', reducer: blogPostReducer })
  const dispatch = useDispatch()
  const rollbar = useRollbar()
  const { globalFontFamily, globalFontWeight, globalFontStyle } =
    useCalculateTypography({})
  const pageId = usePage(pageSelectors.getPageId)

  useEffect(() => {
    async function fetchBlogPostData() {
      try {
        const blogPostData = await blogApi.getBlogPostData(pageId)
        dispatch(blogPostActions.fetchBlogPostData(blogPostData.data))
      } catch (error) {
        console.error(error)
        if (error instanceof InternalError) {
          rollbar.error(error)
        }
      }
    }

    fetchBlogPostData()
  }, [])

  return (
    <PageUi
      fontFamily={globalFontFamily}
      fontWeight={globalFontWeight}
      fontStyle={globalFontStyle}
    >
      {children}
      <ActivePopup />
    </PageUi>
  )
}

BlogPost.propTypes = {
  children: PropTypes.node.isRequired,
}

export default BlogPost
